import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthToken } from '../../models/auth-token';
import { Observable, catchError, map, throwError } from 'rxjs';
import { ApiService } from '../api.service';
import { SharedService } from '../shared/shared.service';
import { IResponse } from '../../models/IResponse';
import { URLConfig } from '../../../../configs/url-config';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  private cookieService = inject(CookieService);
  private sharedService = inject(SharedService);
  private _apiService = inject(ApiService);

  private tokenKey = 'easyInvoices';
  userData: any;
  private token!: AuthToken | string;
  constructor() {
    // this.tokenKey = this.tokenKey;
    // if (this.cookieService.get(this.tokenKey) != '') {
    //   const tokenJson = this.cookieService.get(this.tokenKey);
    //   //console.log(tokenJson);
    //   this.token = JSON.parse(tokenJson);
    // }
  }
  
  refreshToken(): Observable<string> {
      this.userData = localStorage.getItem("user");
     this.userData = JSON.parse(this.userData);
    const obj = {
      token: localStorage.getItem('token'),
    };
    return this._apiService.postRequest<IResponse>(URLConfig.refreshToken, {
      userId: this.userData.userId,
      token: obj.token
    }).pipe(
      map((response: any) => {
        const newToken = response.data.token;
                localStorage.setItem('token', newToken);
        this.sharedService.updateUser(response.data);
        this.setToken(newToken);

        return newToken;
      }),
      catchError((error: any) => {
        // Handle token refresh failure accordingly
        return throwError(error);
      })
    );
  }

  getToken(): AuthToken | string {
    if (this.token == '' && this.cookieService.get(this.tokenKey) != '') {
      const tokenJson = this.cookieService.get(this.tokenKey);
      this.token = JSON.parse(tokenJson);
    }
    return this.token;
  }
  setToken(token: AuthToken): void {
    if (typeof Storage !== 'undefined') {
      this.cookieService.set(this.tokenKey, JSON.stringify(token), 1, '/');

      this.token = token;
    }
  }
  hasToken(): boolean {
    return this.token ? true : false;
  }
  clearToken(): void {
    this.cookieService.delete(this.tokenKey);
  }
  removeFromCookies(key: string) {
    this.cookieService.delete(key);
  }
}
